/* DOMNO. — saved pieces (the wishlist). 12 Sep 2026, rev 11 (one way in: the header star).
 *
 * Three things, one file, loaded on every page from snippets/domno-portal-boot.liquid:
 *
 *   1. THE STAR ON THE PRODUCT PAGE. A square outlined button to the right of Add to cart,
 *      same height. Tap: saved, fills black. Tap again: gone.
 *   2. THE STAR IS THE ACCOUNT ICON. Rev 3 (Dom: "the icons being uneven is throwing me off"):
 *      no separate star. The header's person icon becomes a star, and carries a mark. The same
 *      star sits on the side menu's account row. Tapping the star opens the account drawer
 *      exactly as before.
 *
 *      🔴 REV 12, 14 Sep 2026 (Charlie) — THE NUMBER IS A DOT, AND IT MEANS SOMETHING ELSE.
 *      "I think a red dot is cleaner tbh." An 8px red dot with a white ring, no digit.
 *      It no longer counts saved pieces. IT MEANS: THERE IS A FREE PIECE TO COME AND GET.
 *      A count and a notification cannot share one mark — "3" meaning three saved and "1"
 *      meaning one free piece is the same badge saying two different things on one icon.
 *        signed IN:  the truth, straight off the balance.
 *        signed OUT: no lookup happens at all, because the site cannot know who a visitor is and
 *          MUST NOT be able to find out — an endpoint answering "does this email have rewards?"
 *          for a stranger is an email-enumeration hole. Two local signals instead: a link we
 *          tagged `?dp_rw=1` in a Klaviyo email, or this browser having been signed in before
 *          with a balance. Neither is a promise of a number; the dot only means "come and look".
 *      The side menu still carries it ONLY when signed out, on LOG IN / REGISTER.
 *      The saved-pieces count is gone from the icon. Dom added that on 12 Sep — if it is wanted
 *      back it needs somewhere of its own, not this dot.
 *
 *      REV 9 (Dom). The star carries the theme's own 1.5 stroke, so it sits next to the bag as if
 *      it shipped with it, and the BAG'S badge is restyled to match ours rather than the other
 *      way round — Dom's call, and it is the better circle.
 *   3. THE SAVED SCREEN. Signed in, it is a panel inside the rewards portal (#p-saved, a "Saved"
 *      entry in the drawer menu after Orders). Signed out, it is a sheet of our own that looks
 *      the same, because the portal's signed-out state is the sign-in screen and nothing else.
 *
 * WHERE THE LIST LIVES. A guest's list is localStorage (dp_saved_v1). A signed-in customer's list
 * is the rewards Worker, rewards.domno.com/api/saved, keyed by customer id - the same cid the
 * credits box uses. The first time a customer with a phone list is seen signed in, the phone
 * list is merged up and cleared. If the Worker is down the page still works from what it has.
 *
 * THE NUDGE (Dom: "do it like Cold Culture"). A guest with saves sees, on top of the list:
 * "don't lose your list. sign in to keep it, and there's a free piece in there too." with a
 * Sign in button. That goes to Shopify's login; return_to cannot carry a query string, so the
 * two sessionStorage breadcrumbs from the track page do the rest: dp_reopen=1 makes
 * domno-portal.js reopen the drawer on landing, dp_reopen_to=saved makes domno-nav-account.js
 * call dpGo('saved') once it is up, and the wrapper below answers it.
 *
 * THE NAVIGATION TRAP (see domno-portal-orders.js). domno-portal.js's show() only toggles the
 * panels in its private SECTIONS list, so a bare dpGo('saved') blanks the drawer. dpGo and dpBack
 * are wrapped here, the same way orders.js wraps them: hide our own panel first, answer 'saved'
 * ourselves, delegate everything else. Wrapping composes as long as every wrapper does that.
 *
 * WORDS. It is "saved", never "wishlist", on anything a customer reads. "Piece", "free piece",
 * "on us". Lowercase; the CSS does the shouting.
 *
 * Harness: three states (SV1 empty, SV2 guest with the nudge, SV3 signed in with a sold-out
 * piece) are appended to /?dp=harness. Add one here whenever a state is added to the real thing.
 *
 * SAFE TO DELETE: remove the script line in domno-portal-boot.liquid. Nothing else references it.
 */
(function () {
  'use strict';

  var me = document.currentScript;
  if (!me) return;
  var SIGNED_IN = me.getAttribute('data-signed-in') === '1';
  var CID = (me.getAttribute('data-cid') || '').replace(/[^0-9]/g, '');
  var EMAIL = (me.getAttribute('data-email') || '').trim().toLowerCase();
  var LOGIN = me.getAttribute('data-login') || '/customer_authentication/login';
  var API = 'https://rewards.domno.com/api/saved';
  var LS_KEY = 'dp_saved_v1';
  var RW_FLAG = 'dp_rw_prompt';   /* they came from one of our emails */
  var RW_BAL  = 'dp_rw_bal';      /* what this browser last saw on their account */
  function lsGet(k){ try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v){ try { localStorage.setItem(k, v); } catch (e) {} }

  /* 🔴 THE KLAVIYO LINK. A reward email links in with `?dp_rw=1` and the dot fires for a visitor
     we otherwise cannot identify, prompting a sign-in.
     ⚠ ONLY OUR OWN VALUE IS EVER TAKEN, and the parameter is only stripped when we actually took
     it. On 10 Sep domno-portal-refer.js claimed any `?ref=` it saw, which ate Loox's own
     `?ref=review` and broke every Review button in the portal. `?ref=` is a crowded namespace and
     so is every short parameter — match the value you expect and leave everything else alone.
     Charlie controls which campaigns carry the tag, so the dot never fires off a random email. */
  (function grabRewardLink(){
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('dp_rw') !== '1') return;
      lsSet(RW_FLAG, String(Date.now()));
      u.searchParams.delete('dp_rw');
      var qs = u.searchParams.toString();
      history.replaceState({}, '', u.pathname + (qs ? '?' + qs : '') + u.hash);
    } catch (e) {}
  })();
  /* Shopify's image_url hands back a PROTOCOL-RELATIVE url - //cdn.shopify.com/... - and the
     worker only stores one that starts https://, so every saved image was being dropped on the
     way in and the cards came back blank. Normalised here, and repaired below for anything
     already saved without one. */
  function https(u) {
    u = String(u || '');
    return u.indexOf('//') === 0 ? 'https:' + u : u;
  }
  var PAGE = {
    handle: me.getAttribute('data-handle') || '',
    title: me.getAttribute('data-title') || '',
    price: me.getAttribute('data-price') || '',
    img: https(me.getAttribute('data-img') || ''),
    url: me.getAttribute('data-url') || ''
  };

  /* ---- icons -------------------------------------------------------------------------- */
  function star(size, filled) {
    return '<svg class="dp-star" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12.0 1.6 L14.7 8.88 L22.46 9.2 L16.37 14.02 L18.47 21.5 L12.0 17.2 L5.53 21.5 L7.63 14.02 L1.54 9.2 L9.3 8.88z" ' +
      'fill="' + (filled ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.5" stroke-linejoin="miter"/></svg>';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---- the list ----------------------------------------------------------------------- */
  var items = [];            /* [{handle,title,price,img,url,at}] newest first */
  var serverOk = false;      /* true once the Worker has answered this page load */

  function readLocal() {
    try { var v = JSON.parse(localStorage.getItem(LS_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function writeLocal(list) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(list.slice(0, 60))); } catch (e) {}
  }
  function has(handle) {
    for (var i = 0; i < items.length; i++) if (items[i].handle === handle) return true;
    return false;
  }
  function changed() {
    try { document.dispatchEvent(new CustomEvent('dp:saved:change', { detail: { count: items.length } })); } catch (e) {}
  }

  function api(method, body) {
    var q = '?cid=' + encodeURIComponent(CID) + (EMAIL ? '&email=' + encodeURIComponent(EMAIL) : '');
    var opts = { method: method, credentials: 'omit' };
    if (body) {
      body.cid = CID; body.email = EMAIL;
      opts.headers = { 'content-type': 'application/json' };
      opts.body = JSON.stringify(body);
    }
    return fetch(API + (method === 'GET' ? q : ''), opts)
      .then(function (r) { return r.json(); })
      .then(function (d) { if (!d || !d.ok) throw new Error(d && d.error || 'bad'); serverOk = true; return d.items || []; });
  }

  function load() {
    var local = readLocal();
    if (!SIGNED_IN || !CID) {
      items = local; changed(); return Promise.resolve();
    }
    /* signed in: paint what the browser remembers first, then the truth from the Worker */
    try { var cached = JSON.parse(sessionStorage.getItem('dp_saved_srv') || 'null'); if (Array.isArray(cached)) { items = cached; changed(); } } catch (e) {}
    var p = local.length ? api('POST', { op: 'merge', items: local }) : api('GET');
    return p.then(function (list) {
      items = list;
      if (local.length) { try { localStorage.removeItem(LS_KEY); } catch (e) {} }
      try { sessionStorage.setItem('dp_saved_srv', JSON.stringify(items)); } catch (e) {}
      changed();
    }).catch(function () {
      /* Worker down: keep what we have (cached or the phone list). Never block the page. */
      if (!items.length && local.length) { items = local; changed(); }
    });
  }

  function add(it) {
    if (!it || !it.handle || has(it.handle)) return;
    it.at = new Date().toISOString();
    items.unshift(it); items = items.slice(0, 60);
    if (SIGNED_IN && CID) {
      try { sessionStorage.setItem('dp_saved_srv', JSON.stringify(items)); } catch (e) {}
      api('POST', { op: 'add', items: [it] }).catch(function () { /* stays in the page; next load re-merges nothing, but the tap is not lost this session */ writeLocal(items); });
    } else { writeLocal(items); }
    changed();
  }
  function remove(handle) {
    items = items.filter(function (i) { return i.handle !== handle; });
    if (SIGNED_IN && CID) {
      try { sessionStorage.setItem('dp_saved_srv', JSON.stringify(items)); } catch (e) {}
      api('POST', { op: 'remove', items: [{ handle: handle }] }).catch(function () {});
    } else { writeLocal(items); }
    changed();
  }

  /* ---- styles ------------------------------------------------------------------------- */
  var CSS = [
    /* the account icon, now a star, and its badge. The badge sits where the bag's count sits
       (same offsets against the 24px icon) but red, because it is a notification, not a tally. */
    /* the star itself is the mask in the boot snippet's head CSS; this only holds the badge */
    '.header-account-link__icon{position:relative;display:inline-block;line-height:0;}',
    '.header-account-link .dp-dot,.header-account-link__icon>span[style*="background:#ff0000"]{display:none !important;}',
    /* rev 8: EVERY centring property is !important. Flex centring was already right in
       isolation, but the theme carries `.header-account-link__icon span` rules and a site-wide
       `text-transform:uppercase !important`, and a single-class selector loses to those - so the
       digit kept inheriting a line-height and sitting low. The number is also wrapped in its own
       <i>, so what is centred is a box we control rather than an anonymous run of text. */
    /* 🔴 14 Sep 2026 — THE NUMBER IS NOW A DOT. Charlie: "I think a red dot is cleaner tbh".
       It also had to stop being a tally, because its meaning changed: it no longer counts saved
       pieces, it says A FREE PIECE IS WAITING. A count and a notification cannot share one mark —
       "3" meaning three saved and "1" meaning one free piece would be the same badge saying two
       different things on the same icon.
       The element, the class and every call site are unchanged so nothing else has to move; it is
       8px, it carries no digit, and the <i> it used to centre is hidden rather than removed so a
       cached page cannot render a stray number.
       The white ring is what keeps it readable against the black star underneath it. The offsets
       are against the 24px icon box, not the 44px tap target — see the note in
       snippets/domno-portal-loginurl.liquid about the old dot, which spent three attempts landing
       in empty space for exactly that reason. Worth eyeballing on a phone. */
    '.dp-badge{position:absolute !important;top:-2px;right:-3px;width:8px;height:8px;padding:0 !important;',
      'border-radius:50% !important;background:#ff0000 !important;color:transparent;',
      'display:block !important;border:2px solid #fff !important;box-sizing:content-box !important;',
      'pointer-events:none !important;overflow:hidden;}',
    /* Dom: "change the basket circle to ours". The theme's .cart-link__count is a rounded
       rectangle with its own padding and a 9px/1em line box; these three rules make it the same
       circle as the star's, so the two read as one set. */
    '.cart-link__count{width:16px !important;height:16px !important;min-width:16px !important;',
      'padding:0 !important;top:-4px !important;right:-5px !important;border-radius:12px !important;',
      'display:inline-flex !important;align-items:center !important;justify-content:center !important;',
      'box-sizing:border-box !important;font-family:Helvetica,Arial,sans-serif !important;',
      'font-size:9px !important;font-weight:700 !important;line-height:9px !important;',
      'letter-spacing:0 !important;text-transform:none !important;}',
    /* the digit holder, kept in the markup and hidden, so nothing has to change shape */
    '.dp-badge i{display:none !important;}',

    /* the side menu: the badge after the words on the account row (where the dot used to sit),
       and the Saved row under it */
    '.dpnav__row .dp-badge{position:relative !important;top:-1px;display:inline-block !important;margin-left:7px;vertical-align:middle;}',
    /* LAST, and matching every place a badge can sit. `.dp-badge[hidden]` and
       `.dpnav__row .dp-badge` have the SAME specificity, so when the hide rule came first the
       side-menu rule won on source order and `display:inline-flex !important` beat
       `display:none !important` - which is why the badge stayed put when signed in however
       correctly `hidden` was set. Worth remembering: the element property was right the whole
       time, so a test that reads el.hidden passes while the pixel is wrong. */
    '.dp-badge[hidden],.dpnav__row .dp-badge[hidden],.header-account-link__icon .dp-badge[hidden]{display:none !important;}',

    /* product page */
    '.dp-savewrap{display:flex;gap:10px;align-items:stretch;}',
    '.dp-savewrap>button[type=submit]{flex:1 1 auto;min-width:0;}',
    '.dp-savebtn{flex:0 0 48px;width:48px;min-height:48px;display:inline-flex;align-items:center;justify-content:center;padding:0;',
      'border:1.5px solid rgb(var(--btn-border-color,17,17,17));border-radius:var(--btn-border-radius,0);background:#fff;color:#111;cursor:pointer;',
      '-webkit-appearance:none;appearance:none;-webkit-tap-highlight-color:transparent;}',
    '.dp-savebtn.on{background:#111;color:#fff;border-color:#111;}',
    '.dp-savebtn:active{opacity:.7;}',
    '.dp-toast{position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(8px);background:#111;color:#fff;padding:11px 16px;',
      'font:700 11px/1 Helvetica,Arial,sans-serif;letter-spacing:.08em;text-transform:uppercase;z-index:2147483000;opacity:0;transition:opacity .18s,transform .18s;pointer-events:none;}',
    '.dp-toast.on{opacity:1;transform:translateX(-50%) translateY(0);}',

    /* the saved screen, wherever it is hosted */
    '.dp-sv{--sv-ink:#111;--sv-dim:#6b6b6f;--sv-line:#e4e4e4;--sv-panel:#f6f6f6;--sv-red:#ff0000;',
      '--sv-disp:Montserrat,Helvetica,Arial,sans-serif;--sv-body:Helvetica,"Helvetica Neue",Arial,sans-serif;',
      'font-family:var(--sv-body);color:var(--sv-ink);text-transform:uppercase;}',
    '.dp-sv *{box-sizing:border-box;border-radius:0 !important;}',
    '.dp-sv .sv-sec{font-family:var(--sv-disp);font-weight:900;font-style:italic;font-size:12px;margin:6px 2px 12px;}',
    '.dp-sv .sv-nudge{background:var(--sv-panel);border:1px solid var(--sv-line);padding:16px;margin:0 0 16px;}',
    '.dp-sv .sv-nudge p{margin:0 0 12px;font-size:12px;line-height:1.5;text-transform:none;}',
    '.dp-sv .sv-btn{display:block;width:100%;border:0;padding:14px;background:var(--sv-ink);color:#fff;font-family:var(--sv-body);font-weight:700;font-size:12px;letter-spacing:.06em;text-transform:uppercase;text-align:center;text-decoration:none;cursor:pointer;}',
    '.dp-sv .sv-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;}',
    '.dp-sv .sv-prod{position:relative;}',
    '.dp-sv .sv-prod a{display:block;text-decoration:none;color:inherit;}',
    '.dp-sv .sv-img{aspect-ratio:4/5;background:var(--sv-panel);overflow:hidden;position:relative;}',
    '.dp-sv .sv-img img{width:100%;height:100%;object-fit:cover;display:block;}',
    '.dp-sv .sv-prod.out .sv-img img{opacity:.45;}',
    '.dp-sv .sv-name{font-size:12px;font-weight:700;margin-top:8px;text-transform:none;line-height:1.3;}',
    '.dp-sv .sv-var{font-size:11px;color:var(--sv-dim);margin-top:2px;text-transform:none;}',
    /* the free piece, on the screen: a banner on top and a tag on the pieces that qualify */
    '.dp-sv .sv-free{background:var(--sv-panel);border:1px solid var(--sv-line);padding:16px;margin:0 0 16px;text-align:center;}',
    '.dp-sv .sv-free .lab{display:block;color:var(--sv-dim);font-size:10px;letter-spacing:.16em;margin:0 0 6px;}',
    '.dp-sv .sv-free .big{font-family:var(--sv-disp);font-weight:900;font-style:italic;font-size:24px;line-height:1.05;color:var(--sv-red);margin:0 0 8px;}',
    '.dp-sv .sv-free p{margin:0 0 12px;font-size:12px;line-height:1.5;text-transform:none;}',
    '.dp-sv .sv-free p:last-child{margin-bottom:0;}',
    '.dp-sv .sv-tag{position:absolute;left:6px;top:6px;font-size:9px;font-weight:700;letter-spacing:.12em;padding:4px 6px 3px;background:var(--sv-red);color:#fff;}',
    '.dp-sv .sv-out+.sv-tag,.dp-sv .sv-prod.out .sv-tag{display:none;}',
    /* the real logo in the bars, at the side drawer's 30px */
    '.dp-svsheet__brand img,#domno-portal .bar .brand img{display:block;height:30px;width:auto;}',
    '.dp-sv .sv-price{font-size:11px;color:var(--sv-dim);margin-top:2px;letter-spacing:.04em;}',
    '.dp-sv .sv-out{position:absolute;left:6px;top:6px;font-size:9px;font-weight:700;letter-spacing:.12em;padding:4px 6px 3px;background:var(--sv-ink);color:#fff;}',
    '.dp-sv .sv-rm{position:absolute;top:6px;right:6px;width:30px;height:30px;border:0;background:#fff;color:#111;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;padding:0;-webkit-appearance:none;appearance:none;font-size:15px;line-height:1;}',
    '.dp-sv .sv-empty{text-align:center;color:var(--sv-dim);font-size:12px;line-height:1.6;padding:34px 10px;text-transform:none;}',
    '.dp-sv .sv-empty b{display:block;font-family:var(--sv-disp);font-weight:900;font-style:italic;font-size:18px;color:var(--sv-ink);text-transform:uppercase;margin-bottom:6px;}',

    /* our own sheet, for signed-out visitors */
    '.dp-svsheet{position:fixed;inset:0;z-index:2147483646;display:none;}',
    '.dp-svsheet.open{display:block;}',
    '.dp-svsheet__bg{position:absolute;inset:0;background:rgba(0,0,0,.5);}',
    '.dp-svsheet__box{position:absolute;top:0;right:0;height:100%;width:100%;max-width:460px;background:#fff;overflow-y:auto;-webkit-overflow-scrolling:touch;',
      'box-shadow:-8px 0 30px rgba(0,0,0,.25);animation:dpSvIn .25s ease;}',
    '@keyframes dpSvIn{from{transform:translateX(30px);opacity:.4}to{transform:none;opacity:1}}',
    '.dp-svsheet__bar{display:flex;align-items:center;justify-content:space-between;padding:14px 18px;border-bottom:1px solid #e4e4e4;}',
    '.dp-svsheet__brand{font-family:Montserrat,Helvetica,Arial,sans-serif;font-weight:900;font-style:italic;font-size:20px;text-transform:uppercase;color:#111;}',
    '.dp-svsheet__x{background:none;border:0;font-size:20px;line-height:1;color:#111;cursor:pointer;padding:6px;-webkit-appearance:none;appearance:none;}',
    '.dp-svsheet__body{padding:18px;}'
  ].join('');

  function injectCss() {
    if (document.getElementById('dp-saved-css')) return;
    var s = document.createElement('style');
    s.id = 'dp-saved-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---- the saved screen (one renderer, three hosts) ------------------------------------ */
  /* Which saved pieces could be the free one. Guests: rings (the first step). Signed in with a
     credit: the collection for their step (rings, chains, pendants, then anything). The handles
     come from the collection's own products.json, one fetch, cached for the session. */
  var STEP_COLL = { 1: 'bundle-rings', 2: 'chain-bundle', 3: 'pendant-bundle' };
  var ELIG = null;                      /* null = unknown yet, [] = none, ['*'] = anything */
  /* 14 Sep 2026 — the rung comes from `step` (order count) rather than `tier` (redemptions), and
     `free_choice` means a birthday or referral piece is in hand, which is good for anything in
     all four collections. `tier` is still returned by the worker as an alias of step, so reading
     either works, but step is the one that says what it means. */
  function freeState() {
    if (!SIGNED_IN) return { tier: 1, can: false, free: false };
    var c = window.DP_CREDITS;
    if (!c || !c.ok) return { tier: 1, can: false, free: false };
    return { tier: Number(c.step || c.tier) || 1, can: Number(c.balance) > 0, free: !!c.free_choice };
  }
  function loadEligible(then) {
    if (ELIG) { then(); return; }
    var st = freeState();
    /* free choice is everything, so do not fetch one collection and then tell someone holding a
       birthday piece that only rings count */
    if (st.free || st.tier >= 4) { ELIG = ['*']; then(); return; }
    var coll = STEP_COLL[st.tier] || 'bundle-rings';
    try { var c = sessionStorage.getItem('dp_elig_' + coll); if (c) { ELIG = JSON.parse(c); then(); return; } } catch (e) {}
    fetch('/collections/' + coll + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        ELIG = (d.products || []).map(function (p) { return p.handle; });
        try { sessionStorage.setItem('dp_elig_' + coll, JSON.stringify(ELIG)); } catch (e) {}
        then();
      }).catch(function () { ELIG = []; then(); });
  }
  function eligible(handle) {
    if (!ELIG) return false;
    return ELIG[0] === '*' || ELIG.indexOf(handle) !== -1;
  }
  function nounFor(tier) { return { 1: 'ring', 2: 'chain', 3: 'pendant' }[tier] || 'piece'; }
  /* the minimum in the customer's own currency, the way the portal says it; £25 if the portal
     has not loaded its converter on this page */
  function minSpend() {
    try { if (typeof window.dpMinSpend === 'function') return window.dpMinSpend(25); } catch (e) {}
    return '£25';
  }

  function freeBanner(list, signedIn) {
    var st = freeState();
    var n = 0;
    for (var i = 0; i < list.length; i++) if (eligible(list[i].handle) && !list[i].out) n++;
    /* 🔴 14 Sep 2026 — THIS SAID THE WELCOME PIECE WAS STILL A THING. "make an account and pick a
       free ring with your first order" was true until this morning and is now the single most
       prominent surviving version of a promise the worker will not keep — it sits on a screen
       guests actually reach, unlike the portal panels behind a sign-in.
       The rule now: the FIRST order earns a piece, the SECOND one spends it. Which is a slightly
       longer sentence and a considerably better offer to describe, because it is a reason to come
       back rather than a discount on a first order they were already making.
       Nothing here counts eligible saved pieces for a signed-out guest any more either: whether a
       piece qualifies depends on the rung they are on, and someone with no orders has no rung. */
    var noun = st.free ? 'piece' : nounFor(st.tier);
    if (!signedIn) {
      return '<div class="sv-free"><span class="lab">free pieces</span>' +
             '<div class="big">your first order earns one</div>' +
             '<p>make an account and every order puts a free piece in it, yours to pick on the ' +
             'next one over ' + esc(minSpend()) + '. ' +
             (list.length ? 'your list comes with you.' : 'no code, it just goes in your bag.') + '</p>' +
             '<a class="sv-btn" href="' + esc(LOGIN) + '" data-sv-signin>Sign in or make an account</a></div>';
    }
    if (!st.can) return '';
    return '<div class="sv-free"><span class="lab">your free piece</span>' +
           '<div class="big">' + (n ? (n === 1 ? 'one of these can be free' : n + ' of these can be free') : 'one free ' + noun) + '</div>' +
           '<p>' + (n ? 'the ones marked get it for free can be your free ' + noun + '. pick it and it goes in your bag at £0.' : 'pick yours and it goes in your bag at £0, free on any order over ' + esc(minSpend()) + '.') + '</p>' +
           '<a class="sv-btn" href="#rewards" data-sv-rewards>Pick your free ' + noun + '</a></div>';
  }

  function screenHtml(list, signedIn) {
    var h = '<div class="dp-sv">';
    h += '<h3 class="sv-sec">saved</h3>';
    h += freeBanner(list, signedIn);
    if (!list.length) {
      h += '<div class="sv-empty"><b>nothing saved yet</b>tap the star on a piece and it’ll sit here.</div>';
    } else {
      h += '<div class="sv-grid">';
      for (var i = 0; i < list.length; i++) {
        var it = list[i];
        h += '<div class="sv-prod' + (it.out ? ' out' : '') + '" data-handle="' + esc(it.handle) + '">' +
             '<a href="' + esc(it.url || ('/products/' + it.handle)) + '">' +
               '<div class="sv-img">' + (it.img ? '<img src="' + esc(it.img) + '" alt="' + esc(it.title) + '" loading="lazy">' : '') +
                 (it.out ? '<span class="sv-out">sold out</span>' : '') +
                 (!it.out && eligible(it.handle) && freeState().can ? '<span class="sv-tag">get it for free</span>' : '') + '</div>' +
               '<div class="sv-name">' + esc(it.title || it.handle) + '</div>' +
               (it.variant ? '<div class="sv-var">' + esc(it.variant) + '</div>' : '') +
               (it.price ? '<div class="sv-price">' + esc(it.price) + '</div>' : '') +
             '</a>' +
             '<button type="button" class="sv-rm" aria-label="Remove from saved" title="Remove" data-sv-rm="' + esc(it.handle) + '">&#10005;</button>' +
             '</div>';
      }
      h += '</div>';
    }
    return h + '</div>';
  }

  function wire(host) {
    var rms = host.querySelectorAll('[data-sv-rm]');
    for (var i = 0; i < rms.length; i++) {
      rms[i].addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        remove(this.getAttribute('data-sv-rm'));
        paintHosts();
      });
    }
    var si = host.querySelector('[data-sv-signin]');
    if (si) si.addEventListener('click', function () {
      try { sessionStorage.setItem('dp_reopen', '1'); sessionStorage.setItem('dp_reopen_to', 'saved'); } catch (e) {}
    });
    var rw = host.querySelector('[data-sv-rewards]');
    if (rw) rw.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (typeof window.dpGo === 'function') window.dpGo('rewards');
    });
    refreshStock(host);
    /* the eligibility list lands after the first paint; paint again when it does */
    if (!ELIG) loadEligible(function () { paintHosts(); });
  }

  /* sold out? one small fetch per piece, cached for the session, painted in when it lands */
  var STOCK = {};
  function refreshStock(host) {
    var els = host.querySelectorAll('.sv-prod');
    for (var i = 0; i < els.length && i < 24; i++) {
      (function (el) {
        var h = el.getAttribute('data-handle');
        if (STOCK[h] !== undefined) { mark(el, STOCK[h]); return; }
        try { var c = sessionStorage.getItem('dp_stock_' + h); if (c !== null) { STOCK[h] = c === '0'; mark(el, STOCK[h]); return; } } catch (e) {}
        fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (p) {
            STOCK[h] = !p.available;
            try { sessionStorage.setItem('dp_stock_' + h, p.available ? '1' : '0'); } catch (e) {}
            mark(el, STOCK[h]);
            heal(h, p);
          }).catch(function () {});
      })(els[i]);
    }
  }
  /* Anything saved before the fix above has no picture. This is the same call we already make
     for stock, so the repair is free: take the product's own image, write it back to the list,
     and repaint once. `healed` stops the repaint from asking again forever. */
  var healed = {};
  function heal(handle, p) {
    if (healed[handle]) return;
    var img = https(p.featured_image || (p.images && p.images[0]) || '');
    if (!img) { healed[handle] = 1; return; }
    var hit = false;
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle !== handle || items[i].img) continue;
      items[i].img = img; hit = true;
      if (SIGNED_IN && CID) api('POST', { op: 'add', items: [items[i]] }).catch(function () {});
    }
    healed[handle] = 1;
    if (!hit) return;
    if (SIGNED_IN && CID) { try { sessionStorage.setItem('dp_saved_srv', JSON.stringify(items)); } catch (e) {} }
    else writeLocal(items);
    paintHosts();
  }

  function mark(el, out) {
    if (!out) return;
    el.classList.add('out');
    if (!el.querySelector('.sv-out')) {
      var im = el.querySelector('.sv-img');
      var s = document.createElement('span'); s.className = 'sv-out'; s.textContent = 'sold out';
      if (im) im.appendChild(s);
    }
  }

  /* ---- hosts ---------------------------------------------------------------------------- */
  var hosts = [];
  function paintHosts() {
    for (var i = 0; i < hosts.length; i++) {
      var el = hosts[i];
      if (!el || !document.body.contains(el)) continue;
      el.innerHTML = screenHtml(items, SIGNED_IN);
      wire(el);
    }
  }

  /* signed out: our own sheet */
  var sheet = null;
  function openSheet() {
    injectCss();
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.className = 'dp-svsheet';
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-label', 'Saved pieces');
      sheet.innerHTML =
        '<div class="dp-svsheet__bg" data-sv-close></div>' +
        '<div class="dp-svsheet__box">' +
          '<div class="dp-svsheet__bar"><span class="dp-svsheet__brand">DOMNO.</span>' +
          '<button type="button" class="dp-svsheet__x" aria-label="Close" data-sv-close>&#10005;</button></div>' +
          '<div class="dp-svsheet__body"></div>' +
        '</div>';
      sheet.addEventListener('click', function (ev) {
        if (ev.target.hasAttribute && ev.target.hasAttribute('data-sv-close')) closeSheet();
      });
      document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeSheet(); });
      document.body.appendChild(sheet);
      hosts.push(sheet.querySelector('.dp-svsheet__body'));
    }
    paintHosts();
    sheet.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('open');
    document.documentElement.style.overflow = '';
  }

  /* signed in: a panel in the portal + a menu entry + the dpGo/dpBack wrappers */
  var portalWired = false, mineOpen = false;
  function ensurePortalPanel() {
    var body = document.querySelector('#domno-portal .body');
    if (!body) return null;
    var p = document.getElementById('p-saved');
    if (!p) {
      p = document.createElement('div'); p.id = 'p-saved'; p.className = 'panel';
      body.appendChild(p);
      hosts.push(p);
    }
    return p;
  }
  function ensureMenuEntry() {
    var menu = document.getElementById('dp-menu');
    if (!menu || menu.querySelector('#m-saved')) return;
    var a = document.createElement('a');
    a.id = 'm-saved'; a.textContent = 'Saved';
    a.addEventListener('click', function () { if (window.dpGo) window.dpGo('saved'); });
    var after = menu.querySelector('#m-orders');
    if (after && after.nextSibling) menu.insertBefore(a, after.nextSibling);
    else if (after) menu.appendChild(a);
    else menu.insertBefore(a, menu.firstChild);
  }
  function showMine() {
    var p = ensurePortalPanel(); if (!p) return;
    var all = document.querySelectorAll('#domno-portal .panel');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('on');
    var mi = document.querySelectorAll('#dp-menu a');
    for (var j = 0; j < mi.length; j++) mi[j].classList.toggle('on', mi[j].id === 'm-saved');
    paintHosts();
    p.classList.add('on');
    mineOpen = true;
    var menu = document.getElementById('dp-menu'); if (menu) menu.classList.remove('on');
    var back = document.getElementById('dp-back'); if (back) back.style.display = 'block';
    try {
      var dp = document.getElementById('domno-portal'); if (dp) dp.scrollTop = 0;
      var o = document.getElementById('dp-overlay'); if (o) o.scrollTop = 0;
      window.scrollTo(0, 0);
    } catch (e) {}
  }
  function hideMine() {
    var p = document.getElementById('p-saved'); if (p) p.classList.remove('on');
    mineOpen = false;
  }
  function wirePortal() {
    if (portalWired) return true;
    if (typeof window.dpGo !== 'function' || !document.querySelector('#domno-portal .body')) return false;
    portalWired = true;
    injectCss();
    ensurePortalPanel();
    ensureMenuEntry();
    var origGo = window.dpGo;
    window.dpGo = function (id) {
      hideMine();
      if (id === 'saved') { showMine(); return; }
      return origGo.apply(this, arguments);
    };
    var origBack = window.dpBack;
    window.dpBack = function () {
      if (mineOpen) { hideMine(); if (window.dpGo) window.dpGo('home'); return; }
      return origBack.apply(this, arguments);
    };
    return true;
  }

  function openSaved() {
    if (SIGNED_IN) {
      var overlay = document.getElementById('dp-overlay');
      if (overlay) {
        document.body.appendChild(overlay);
        overlay.style.zIndex = '2147483647';
        overlay.classList.add('open');
        document.documentElement.style.overflow = 'hidden';
        var tries = 0, iv = setInterval(function () {
          tries++;
          if (wirePortal()) { clearInterval(iv); window.dpGo('saved'); }
          else if (tries > 40) clearInterval(iv);
        }, 100);
        return;
      }
    }
    openSheet();
  }
  window.dpOpenSaved = openSaved;

  /* ---- the drawer's own menu (Dom, rev 9) -------------------------------------------------
     Rewards reads red, everything else grey, and whatever you are looking at reads black. "Hit
     us up" is given the drawer's OWN `.out` class — the one Sign out already wears — so the two
     match exactly by construction rather than by a number copied across. */
  var MENU_CSS = [
    '#domno-portal #dp-menu a#m-rewards{color:#ff0000;}',
    '#domno-portal #dp-menu a#m-rewards.on{color:#111;}'
  ].join('');
  function menuStyle() {
    if (!document.getElementById('dp-menu-css')) {
      var st = document.createElement('style');
      st.id = 'dp-menu-css';
      st.textContent = MENU_CSS;
      document.head.appendChild(st);
    }
    var menu = document.getElementById('dp-menu');
    if (!menu) return;
    var as = menu.querySelectorAll('a');
    for (var i = 0; i < as.length; i++) {
      var a = as[i];
      if (/hit us up/i.test(a.textContent || '') && !a.classList.contains('out')) a.classList.add('out');
    }
  }

  /* ---- the real logo in the bars ---------------------------------------------------------
     The side drawer's is the right one (nav-account clones img.logo__image at 30px). Same here:
     the portal's text "DOMNO." in .bar .brand, and our sheet's, become that image. */
  function logoInto(el) {
    if (!el || el.querySelector('img')) return;
    var src = document.querySelector('img.logo__image');
    if (!src) return;
    var img = src.cloneNode(false);
    img.removeAttribute('itemprop'); img.removeAttribute('loading'); img.removeAttribute('width'); img.removeAttribute('height');
    img.alt = src.getAttribute('alt') || 'DOMNO.';
    el.textContent = '';
    el.appendChild(img);
  }
  function brandLogos() {
    logoInto(document.querySelector('#domno-portal .bar .brand'));
    logoInto(document.querySelector('.dp-svsheet__brand'));
    menuStyle();
  }

  /* ---- the badge number ------------------------------------------------------------------ */
  /* 🔴 14 Sep 2026 — THE DOT MEANS ONE THING: THERE IS A FREE PIECE TO COME AND GET.
     It used to be a count of saved pieces (plus one signed out). Charlie's call: a red dot,
     meaning a free item is sitting on a logged-in account, or that someone has arrived from one
     of our emails and should sign in to see where they are up to.

     SIGNED IN it is the truth, straight off the balance.

     SIGNED OUT the site genuinely cannot know who anyone is, and it must not be able to find out:
     any endpoint that answered "does this email have rewards?" to an unauthenticated caller would
     be an email-enumeration hole. So there is no lookup here at all. Two local signals instead,
     and both reveal nothing to anyone who was not already the customer:
       1. they clicked a link WE tagged `?dp_rw=1` in a Klaviyo email, or
       2. this browser was signed in before and had a balance when it last looked.
     Neither is a promise of a number — the dot only ever means "come and look". The real balance
     replaces it the moment they sign in, so a piece spent on another device costs nothing worse
     than one wasted tap. */
  function rewardWaiting() {
    if (SIGNED_IN) {
      var c = window.DP_CREDITS;
      return !!(c && c.ok && Number(c.balance) > 0);
    }
    var f = lsGet(RW_FLAG);
    if (f && (Date.now() - Number(f)) < 30 * 86400000) return true;
    try {
      var st = JSON.parse(lsGet(RW_BAL) || 'null');
      if (st && Number(st.b) > 0 && (Date.now() - Number(st.at)) < 120 * 86400000) return true;
    } catch (e) {}
    return false;
  }
  window.dpRewardWaiting = rewardWaiting;

  /* Remember the balance while we legitimately know it, so the dot can survive a sign-out on this
     browser. Written on every paint rather than once, because DP_CREDITS lands asynchronously. */
  function stashBalance() {
    if (!SIGNED_IN) return;
    var c = window.DP_CREDITS;
    if (!c || !c.ok) return;
    try { lsSet(RW_BAL, JSON.stringify({ b: Number(c.balance) || 0, at: Date.now() })); } catch (e) {}
  }

  /* ---- the header: only the badge ---------------------------------------------------------
     The star itself is drawn in CSS from the head (see snippets/domno-portal-boot.liquid), so it
     is on screen before the first paint and never flashes the person icon it replaced. All this
     does is hang the badge on it. */
  function headerStar() {
    var icons = document.querySelectorAll('.header-account-link__icon');
    for (var i = 0; i < icons.length; i++) {
      var ic = icons[i];
      if (ic.getAttribute('data-dp-star')) continue;
      injectCss();
      ic.setAttribute('data-dp-star', '1');
      var b = document.createElement('span');
      b.className = 'dp-badge'; b.hidden = true;
      b.setAttribute('data-dp-badge', 'header');
      b.innerHTML = '<i></i>';
      ic.appendChild(b);
      var btn = ic.closest('.header-account-link');
      if (btn) btn.setAttribute('aria-label', 'Your account and saved pieces');
      paintDot();
    }
  }
  /* Writes only when the number changed. This runs from a MutationObserver, and an
     unconditional textContent write IS a mutation - the loop the rewards skill warns about. */
  /* Tapping the star with something saved goes to the LIST, because that is what the number on
     it counts. Signed out that list carries the sign-in nudge (Dom: "the drop down is different
     - about the wishlist + you get a free piece - to sign them in"); signed in it is the Saved
     panel. With nothing saved the star does what it always did and opens the account.
     Caught at document level in the capture phase so the button's own inline onclick - which
     opens the portal on Home - never runs first. Rev 11: this is now the only way in from the
     header, since the Saved row has gone from the side menu. */
  document.addEventListener('click', function (ev) {
    if (!items.length) return;
    var t = ev.target && ev.target.closest ? ev.target.closest('.header-account-link') : null;
    if (!t) return;
    ev.preventDefault(); ev.stopPropagation();
    openSaved();          /* the sheet signed out, the portal's Saved panel signed in */
  }, true);

  function paintDot() {
    stashBalance();
    var waiting = rewardWaiting();
    var bs = document.querySelectorAll('.dp-badge');
    for (var i = 0; i < bs.length; i++) {
      var el = bs[i], where = el.getAttribute('data-dp-badge'), show;
      /* rev 9: the side menu is clean when signed in. Only the signed-out nudge survives there.
         The header star carries it in both states, because signed in it is the thing that tells
         someone a free piece is sitting in their account. */
      if (where === 'saved') show = false;
      else if (where === 'account') show = !SIGNED_IN && waiting;
      else show = waiting;
      /* ⚠ NOTHING IS WRITTEN UNLESS IT CHANGED. This runs from a MutationObserver, and an
         unconditional write IS a mutation — the loop that locked a tab for 45 seconds. There is
         no text to write any more, which removes the commonest way that used to happen. */
      if (el.hidden !== !show) el.hidden = !show;
    }
  }

  /* ---- the side menu: the badge on the account row, and nothing else --------------------
     REV 11 (Dom): the Saved row is gone from the mobile menu. Saved is reached from the header
     star, which is on every page in both states, and from the portal's own menu once signed in -
     a third door on a menu that is meant to stay short was one too many. */
  function navRows() {
    var rows = document.querySelectorAll('.dpnav__row');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var label = row.querySelector('span');
      if (!label || row.getAttribute('data-dp-saved')) continue;
      var txt = (label.textContent || '').trim().toLowerCase();
      if (!/^(log in|your account)/.test(txt)) continue;
      injectCss();
      row.setAttribute('data-dp-saved', '1');
      /* the dot nav-account drew is retired; the badge sits where it sat, after the words.
         Signed in it never shows here - paintDot hides it; the header star carries the dot. */
      var dot = label.querySelector('.dpnav__dot'); if (dot) dot.parentNode.removeChild(dot);
      var bd = document.createElement('span');
      bd.className = 'dp-badge'; bd.hidden = true;
      bd.setAttribute('data-dp-badge', 'account');
      bd.innerHTML = '<i></i>';
      label.appendChild(bd);
      /* anything left over from rev 9/10, on a drawer the theme cloned before this ran */
      var stale = row.parentNode.querySelector('[data-dp-saved-row]');
      if (stale) stale.parentNode.removeChild(stale);
      paintDot();
    }
  }

  /* ---- product page --------------------------------------------------------------------- */
  var toastEl = null, toastT = null;
  function toast(msg) {
    injectCss();
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'dp-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 1400);
  }
  /* The variant they had picked when they tapped - "Silver / 8" - read off the product form,
     named from the product's own .js, and stamped onto the saved piece after the fact. */
  function withVariant(it) {
    var inp = document.querySelector('form.js-product-form input[name="id"], .product-form input[name="id"]');
    var vid = inp ? String(inp.value || '') : '';
    if (!vid) return;
    fetch('/products/' + encodeURIComponent(it.handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return String(x.id) === vid; })[0];
        if (!v) return;
        var label = (v.title && v.title !== 'Default Title') ? v.title : '';
        for (var i = 0; i < items.length; i++) {
          if (items[i].handle !== it.handle) continue;
          items[i].variant = label;
          items[i].url = it.url + (it.url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + vid;
          if (v.price != null && !items[i].price) items[i].price = '';
          var one = items[i];
          if (SIGNED_IN && CID) { try { sessionStorage.setItem('dp_saved_srv', JSON.stringify(items)); } catch (e) {} api('POST', { op: 'add', items: [one] }).catch(function () {}); }
          else writeLocal(items);
        }
        changed();
      }).catch(function () {});
  }

  function pdpStar() {
    if (!PAGE.handle) return;
    var rows = document.querySelectorAll('.quantity-submit-row__submit');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.querySelector('.dp-savebtn')) continue;
      /* Dom: "remove save from the side cart". The cart drawer renders the same buy-button
         markup, so the star was landing in there too. The product page is the only place a save
         makes sense - there is nothing to save in a cart you are already holding. NOT gated on
         .quickbuy-content: main-product.liquid puts that class on the real product form as well. */
      if (row.closest('.cart-drawer,#cart-drawer,.mini-cart,.drawer--cart,[class*="cart-drawer"],[id*="CartDrawer"]')) continue;
      var btn = row.querySelector('button[type=submit]');
      if (!btn) continue;
      injectCss();
      var wrap = document.createElement('div');
      wrap.className = 'dp-savewrap';
      btn.parentNode.insertBefore(wrap, btn);
      wrap.appendChild(btn);
      var sb = document.createElement('button');
      sb.type = 'button';
      sb.className = 'dp-savebtn' + (has(PAGE.handle) ? ' on' : '');
      sb.setAttribute('aria-label', has(PAGE.handle) ? 'Saved' : 'Save this piece');
      sb.innerHTML = star(22, has(PAGE.handle));
      sb.addEventListener('click', function () {
        if (has(PAGE.handle)) { remove(PAGE.handle); toast('removed'); }
        else {
          var it = { handle: PAGE.handle, title: PAGE.title, price: PAGE.price, img: PAGE.img, url: PAGE.url };
          add(it);
          toast(SIGNED_IN ? 'saved' : 'saved — sign in to keep it');
          withVariant(it);
        }
      });
      wrap.appendChild(sb);
    }
  }
  function paintPdp() {
    var on = has(PAGE.handle);
    var bs = document.querySelectorAll('.dp-savebtn');
    for (var i = 0; i < bs.length; i++) {
      if (bs[i].classList.contains('on') === on) continue;
      bs[i].classList.toggle('on', on);
      bs[i].innerHTML = star(22, on);
      bs[i].setAttribute('aria-label', on ? 'Saved' : 'Save this piece');
    }
  }

  /* ---- harness -------------------------------------------------------------------------- */
  function harness() {
    if (new URLSearchParams(location.search).get('dp') !== 'harness') return;
    var fx = [
      { handle: 'starpoint-ring', title: 'Starpoint Ring', price: '£25.00', img: '', url: '#', variant: 'Silver / 8' },
      { handle: 'cuban-chain', title: 'Cuban Chain 5mm', price: '£45.00', img: '', url: '#', variant: '20"' },
      { handle: 'cross-pendant', title: 'Cross Pendant', price: '£35.00', img: '', url: '#' },
      { handle: 'signet-ring', title: 'Signet Ring', price: '£30.00', img: '', url: '#', out: true }
    ];
    var screens = [
      ['SV1', 'Saved, empty', 'nothing starred yet, either state', screenHtml([], true)],
      ['SV2', 'Saved, guest', 'three on the phone, the sign-in nudge on top', screenHtml(fx.slice(0, 3), false)],
      ['SV3', 'Saved, signed in', 'four in the account, one sold out', screenHtml(fx, true)]
    ];
    var tries = 0, iv = setInterval(function () {
      tries++;
      var grid = document.querySelector('#dp-harness .grid');
      if (!grid) { if (tries > 60) clearInterval(iv); return; }
      clearInterval(iv);
      injectCss();
      var html = '';
      for (var i = 0; i < screens.length; i++) {
        var s = screens[i];
        html += '<div class="card"><div class="cap"><div class="id">' + s[0] + '</div>' +
                '<div class="nm">' + s[1] + '</div><div class="wh">' + s[2] + '</div></div>' +
                '<div class="scr"><div class="p">' + s[3] + '</div></div></div>';
      }
      grid.insertAdjacentHTML('beforeend', html);
    }, 120);
  }

  /* ---- wiring --------------------------------------------------------------------------- */
  document.addEventListener('dp:saved:change', function () { paintDot(); paintPdp(); paintHosts(); });

  function start() {
    injectCss();
    load();
    headerStar();
    navRows();
    pdpStar();
    brandLogos();
    menuStyle();
    harness();
    if (SIGNED_IN) {
      var n = 0, iv = setInterval(function () { n++; if (wirePortal() || n > 100) clearInterval(iv); }, 150);
    }
    /* the header can be re-rendered (sticky clone, section reload); keep the star on it */
    if (window.MutationObserver) {
      new MutationObserver(function () { headerStar(); navRows(); pdpStar(); brandLogos(); }).observe(document.body, { childList: true, subtree: true });
    }
    /* the credits box loads after us and changes the number */
    var m = 0, miv = setInterval(function () { m++; paintDot(); if (m > 40) clearInterval(miv); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();